import { cva } from "cva";

export const socialMediaShareStyles = cva("", {
  variants: {
    size: {
      large:
        "flex w-full items-center justify-between border-1 border-y-gray-300 px-s py-m",
      small:
        "flex min-w-[160px] items-center justify-between border-1 border-y-gray-300 px-s py-xs",
    },
  },
});
